import { render } from "./timer-loading-bar.vue?vue&type=template&id=272baebc&ts=true"
import script from "./timer-loading-bar.vue?vue&type=script&lang=ts"
export * from "./timer-loading-bar.vue?vue&type=script&lang=ts"

import "./timer-loading-bar.vue?vue&type=style&index=0&id=272baebc&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__